export default {
	filterRolPermission: (state) => state.rol_permission.filter((dato) => dato.permission_id === state.id_permission),
};
